/*
创建者 魏强(2018.2.1)
人气热推
*/
<template>
	<div class="home-module mb">
        <h3 class="module-title"><span>人气热推</span></h3>
        <div class="hotSale clearfix">
        	<div class="hotSale-item"
        		v-for="(store,index) in hotPersonalStoreList"
				v-if="index<4"
        		:key="store.storeId">
        		<router-link  :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}" target="_blank" >
				    <img  :src="store.storeBanner" class="hotSale-item-img" :alt="store.storeName" />
				</router-link>

            	<router-link  :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}" target="_blank" class="hotSale-info">
				    <img  :src="store.storeLogo" width="100" height="50" />
				    <p class="hotSale-name">
	                	<span class="hotSale-store">{{store.storeName}}</span>
	                	<span class="hotSale-rate">好评率：{{store.praiseRate*100}}%</span>
                	</p>
				</router-link>

                <div class="hotSale-hover">
                	<div class="hotSale-pro-list clearfix">
						<router-link
							class="hotSale-hover-pro"
							v-for="goods in hotPersonalStoreGoodList"
							v-if="goods.storeId==store.storeId"
							:key="goods.goodsId"
							:to="{path:'/goods',query:{goods_id:goods.goodsId}}" target="_blank"	>
						    <img
						    :src="goods.design_image || goods.designImage" width="140px" height="177px" style="cursor: pointer;" :alt="store.storeName" />
						    <span>￥ {{goods.price}}</span>
						</router-link>
                    </div>
                    <router-link  :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}" target="_blank" >
					    <img  :src="store.storeLogo" class="hotSale-hover-logo" width="100" height="50" :alt="store.storeName" />
					</router-link>
                    <a href="javascript:void(0);" onclick="collect_store(${hotPersonalStore.storeId},this,'store_collect');" class="hotSale-favorite">收藏本店</a>
                    <router-link  :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}" target="_blank" class="enter-btn" >
					    进入店铺
					</router-link>
                </div>
            	<span class="jpStore"></span>
            </div>
        </div>
    </div>
</template>
<script>

export default{
	props:['hotPersonalStoreGoodList','hotPersonalStoreList'],
	data(){
		return{};
	}
}
</script>
<style scoped>
.hotSale-item{
	height: 350px;
}
.hotSale-pro-list{
	height: 202px;
	overflow: hidden;
}
.hotSale-pro-list a{
	margin-bottom: 50px;
}

</style>


// WEBPACK FOOTER //
// popular-hot.vue?b05dfb76